<!-- src/app/components/toast/toast.component.html -->
<div class="toast-container">
  @for (toast of toasts(); track toast.id) {
    <div
      class="toast rounded-2"
      [class.success]="toast.type === ToastType.Success"
      [class.error]="toast.type === ToastType.Error"
      [class.info]="toast.type === ToastType.Info"
      [class.warning]="toast.type === ToastType.Warning"
      (click)="dismiss(toast.id)"
    >
      <div class="toast-content">
        @if (toast.type === ToastType.Success) {
          <span class="emoji">✅</span>
        }
        @if (toast.type === ToastType.Error) {
          <span class="emoji">❌</span>
        }
        @if (toast.type === ToastType.Info) {
          <span class="emoji">ℹ️</span>
        }
        @if (toast.type === ToastType.Warning) {
          <span class="emoji">⚠️</span>
        }
        <span class="message">{{ toast.message }}</span>
      </div>
      @if (toast.duration > 0) {
        <div class="progress" [style.animation-duration.ms]="toast.duration"></div>
      }
    </div>
  }
</div>
